module.exports = __webpack_public_path__ + "img/64.689c208e.png";